document.addEventListener('DOMContentLoaded', function() {
  function fixSubscriptionAlignment() {
    // Fix frequency rows
    document.querySelectorAll('.group_list_item').forEach(function(label) {
      label.style.alignItems = 'center';
      label.style.marginBottom = '0';
      label.style.height = '44px';

      var wrapper = label.querySelector('.title_and_price_wrapper');
      if (wrapper) {
        wrapper.style.alignItems = 'center';
        wrapper.style.alignSelf = 'center';
        wrapper.style.margin = '0';
        wrapper.style.lineHeight = '1';
      }

      var radio = label.querySelector('input[type="radio"]');
      if (radio) {
        radio.style.marginTop = '0';
        radio.style.alignSelf = 'center';
      }
    });

    // Fix one-time purchase label
    document.querySelectorAll('.one_time_purchase_option_app_block').forEach(function(el) {
      el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.height = '44px';
      el.style.margin = '0';
    });
  }

  fixSubscriptionAlignment();
  setTimeout(fixSubscriptionAlignment, 500);
  setTimeout(fixSubscriptionAlignment, 1500);
});